import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getClient } from '../../graphql/apolloClient'
import graphql from 'graphql-tag'
import { Col } from '../styled'
import gql from 'graphql-tag'
import { Thumbnail, ResultsGrid, ResultsWrapper, CloseButton, Title, Upcoming } from '../styled/ResultsGrid'
import { Flex } from '../styled/Flex'
import _get from 'lodash.get'
import SearchBox, { SearchLabel } from '../SearchBox'
import Loader from '../styled/Loader'
import NormalLayout from '../VideoAssetFinder/NormalLayout'
import { isBefore } from 'date-fns'

const GRAPHQL_URL = 'https://tv4se-graphql.a2d.tv/graphql'

const isUpcoming = broadcastDateTime => isBefore(new Date(), broadcastDateTime)

const apolloClient = getClient(GRAPHQL_URL)

export default class VideoAssetFinderV2 extends Component {
  state = {
    suggestions: [],
    totalHits: 0,
    selected: null,
    extension: null,
    query: '',
    offset: 0,
    noHits: false,
  }

  async componentDidMount() {
    const { parentExtension, selectedId, handleExpiredAsset } = this.props

    if (!parentExtension) {
      window.contentfulExtension &&
        window.contentfulExtension.init(extension => {
          this.setState({
            extension,
          })

          const currentFieldValue = extension.field.getValue()

          if (currentFieldValue) {
            this.search(currentFieldValue).then(s => {
              const { videoAssetForPlugin } = s
              this.setState(
                videoAssetForPlugin
                  ? {
                      selected: {
                        id: videoAssetForPlugin.id,
                        image: videoAssetForPlugin.image,
                        title: videoAssetForPlugin.title,
                      },
                    }
                  : { selected: { id: currentFieldValue } },
                () => {
                  this.closeResults()
                  this.state.extension.window.updateHeight(250)
                }
              )
            })
          }
        })
    } else {
      const initialValues = await apolloClient.query({
        query: gql(`
      query videoAssetForPlugin($id: String!) {
      videoAsset(id: $id) {
        id
        title
        description
        image
        publishedDateTime
      }
    }`),
        variables: { id: selectedId },
      })
      if (_get(initialValues, 'data.videoAsset')) {
        const { id, image, title, publishedDateTime } = initialValues.data.videoAsset
        this.setState({ selected: { id, image, title, publishedDateTime } })
      } else {
        if (!!handleExpiredAsset) {
          // Initial asset doesn't exist anymore, notify parent
          await handleExpiredAsset()
        }
      }
    }
  }

  search = async (q, offset = 0) => {
    return new Promise((resolve, reject) => {
      let newState = {
        query: q,
        offset: offset,
      }

      if (offset === 0) {
        newState = { ...newState, suggestions: [] }
      }

      this.setState(
        {
          ...newState,
          fetchingResults: true,
          noHits: false,
        },
        () => {
          return apolloClient
            .query({
              query: graphql(`
                query videoAssetForPlugin($q: String!) {
                  videoAssetForPlugin(id: $q) {
                    id
                    title
                    description
                    image
                    publishedDateTime
                  }
                }
              `),
              variables: {
                q: this.state.query,
              },
            })
            .then(r => {
              if (r.data.videoAssetForPlugin) {
                this.setState({
                  suggestions: [r.data.videoAssetForPlugin],
                  totalHits: 1,
                  fetchingResults: false,
                })
                this.state.extension && this.state.extension.window.updateHeight(640)
              } else {
                this.setState({
                  noHits: true,
                  fetchingResults: false,
                })
              }

              resolve(r.data)
            })
            .catch(e => reject(e))
        }
      )
    })
  }
  renderResult = data => (
    <ResultsWrapper>
      <CloseButton onClick={this.closeResults}>Stäng</CloseButton>
      <ResultsGrid>
        <Flex>
          <div style={{ flexGrow: 1, padding: '3px', paddingLeft: '5px' }}>
            <strong>{this.state.totalHits}</strong> träffar
          </div>
        </Flex>
        {data.map((suggestion, i) => (
          <Col key={i} onClick={() => this.setSelected(suggestion)}>
            <Thumbnail src={suggestion.image} />
            <Title>{suggestion.title}</Title>
            {isUpcoming(suggestion.publishedDateTime) && <Upcoming>Kommande</Upcoming>}
          </Col>
        ))}
      </ResultsGrid>
    </ResultsWrapper>
  )
  closeResults = () => {
    this.setState({ suggestions: [] }, () => {
      this.state.extension && this.state.extension.window.updateHeight(250)
    })
    if (this.props.onCloseResults) {
      this.props.onCloseResults()
    }
  }
  setSelected = asset => {
    this.closeResults()
    if (this.props.onVideoAssetSelected) {
      this.props.onVideoAssetSelected(asset)
      this.setState({ selected: asset })
    } else {
      this.setState({ selected: asset }, () => {
        if (this.state.extension) {
          const value = this.state.selected ? this.state.selected.id + '' : null
          this.state.extension.field.setValue(value).catch(error => {
            console.log('Error: ' + JSON.stringify(error))
          })
        }
      })
    }
  }
  render() {
    const { smallLayout } = this.props
    const { suggestions, selected, noHits, fetchingResults, query } = this.state
    return (
      <>
        {smallLayout ? (
          <div> {selected && selected.id} </div>
        ) : (
          <NormalLayout
            renderResult={this.renderResult}
            suggestions={suggestions}
            selected={selected}
            noHits={noHits}
            reset={() => this.setSelected(null)}
            fetchingResults={fetchingResults}
            isUpcoming={selected && isUpcoming(selected.publishedDateTime)}
          />
        )}

        <>
          <SearchLabel>Sökterm:</SearchLabel>
          <SearchBox query={query} handleSearch={this.search} />
          {fetchingResults && <Loader />}
          {suggestions && suggestions.length > 0 && this.renderResult(suggestions)}
          {noHits && <p>Inga träffar</p>}
        </>
      </>
    )
  }
}

VideoAssetFinderV2.propTypes = {
  parentExtension: PropTypes.any,
  onVideoAssetSelected: PropTypes.func,
}
